import { cn } from "@/utils/cn";

const PillCheckmark = () => (
  <svg
    width="13"
    height="10"
    viewBox="0 0 13.0039 9.50189"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="shrink-0"
  >
    <path
      d="M12.7826 1.2813L4.78255 9.2813C4.71287 9.35122 4.63008 9.4067 4.53891 9.44455C4.44775 9.48241 4.35001 9.50189 4.2513 9.50189C4.15259 9.50189 4.05485 9.48241 3.96369 9.44455C3.87252 9.4067 3.78973 9.35122 3.72005 9.2813L0.220051 5.7813C0.150286 5.71154 0.0949458 5.62871 0.0571893 5.53756C0.0194329 5.44641 1.03958e-09 5.34871 0 5.25005C-1.03958e-09 5.15139 0.0194329 5.05369 0.0571893 4.96254C0.0949458 4.87139 0.150286 4.78857 0.220051 4.7188C0.289816 4.64904 0.372638 4.5937 0.46379 4.55594C0.554942 4.51818 0.652639 4.49875 0.751301 4.49875C0.849963 4.49875 0.947659 4.51818 1.03881 4.55594C1.12996 4.5937 1.21279 4.64904 1.28255 4.7188L4.25193 7.68818L11.7213 0.220051C11.8622 0.0791546 12.0533 0 12.2526 0C12.4518 0 12.6429 0.0791546 12.7838 0.220051C12.9247 0.360947 13.0039 0.552044 13.0039 0.751301C13.0039 0.950558 12.9247 1.14165 12.7838 1.28255L12.7826 1.2813Z"
      fill="#620AD5"
    />
  </svg>
);

interface SelectablePillProps {
  label: string;
  selected?: boolean;
  plus?: boolean;
  onClick: () => void;
  className?: string;
}

export const SelectablePill = ({
  label,
  selected,
  plus,
  onClick,
  className,
}: SelectablePillProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex items-center gap-1 rounded-full text-sm font-medium h-[42px] pl-3.5 pr-3 w-full transition-all",
        plus
          ? "bg-os-brand text-white"
          : selected
            ? "bg-white border border-os-brand text-os-brand shadow-[0px_8px_32.35px_rgba(64,0,255,0.1)]"
            : "bg-white border border-[#ebe0fb] text-os-brand shadow-[0px_8px_32.35px_rgba(64,0,255,0.1)]",
        className,
      )}
    >
      <span className="flex-1 text-left truncate">{label}</span>
      {selected && !plus && <PillCheckmark />}
      {plus && (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0">
          <path d="M14 7C14 7.22278 13.9115 7.43644 13.754 7.59397C13.5964 7.7515 13.3828 7.84 13.16 7.84H7.84V13.16C7.84 13.3828 7.7515 13.5964 7.59397 13.754C7.43644 13.9115 7.22278 14 7 14C6.77722 14 6.56356 13.9115 6.40603 13.754C6.2485 13.5964 6.16 13.3828 6.16 13.16V7.84H0.84C0.617218 7.84 0.403561 7.7515 0.24603 7.59397C0.0884998 7.43644 0 7.22278 0 7C0 6.77722 0.0884998 6.56356 0.24603 6.40603C0.403561 6.2485 0.617218 6.16 0.84 6.16H6.16V0.84C6.16 0.617218 6.2485 0.403561 6.40603 0.24603C6.56356 0.0884998 6.77722 0 7 0C7.22278 0 7.43644 0.0884998 7.59397 0.24603C7.7515 0.403561 7.84 0.617218 7.84 0.84V6.16H13.16C13.3828 6.16 13.5964 6.2485 13.754 6.40603C13.9115 6.56356 14 6.77722 14 7Z" fill="white"/>
        </svg>
      )}
    </button>
  );
};
